module.exports = __webpack_public_path__ + "static/media/YS_badgeCertified.37acd928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_badgeCertified.png
// module id = 1428
// module chunks = 0